import React, { Component } from "react";

class footer extends Component {
  render() {
    return (
      <div className="footPush">
        <div className="photoSpacer"></div>
        <div className="Footer">
          <p style={{ textAlign: "center" }} className="bold">
            Jack Frederick
          </p>
            <p className="footColB" style={{ color: "#555" }}>
              This site is home made and self hosted. | <a href="/privacy" style={{ color: "#777", textDecoration: "none", transition: "color 0.2s ease" }} onMouseOver={(e) => e.target.style.color = "#bbb"} onMouseOut={(e) => e.target.style.color = "#777"}>Privacy Policy</a>
            </p>
            <div className="photoSpacer"></div>
          </div>
        </div>
    );
  }
}

export default footer;
